module.exports = __webpack_public_path__ + "img/svs.4ceebfff.jpg";